/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VersionInfo } from '../models/VersionInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VersionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the webapi's version
     * Returns the version of the webapi (Access: all)
     * @returns VersionInfo User's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getVersion(): CancelablePromise<VersionInfo | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/version',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
